import { inferenceHttp } from '@/lib/api/inference-client';
import { logger } from '@/lib/utils/logger';
import {
  SpringboardCategoriesService,
  type SpringboardCategoriesResponseDto,
  type SpringboardCategoryItemDto,
  type UpsertSpringboardCategoriesDto,
} from '@inference.engine/api-client/web';

export type {
  SpringboardCategoriesResponseDto,
  SpringboardCategoryItemDto,
  UpsertSpringboardCategoriesDto,
};

export const getSpringboardCategories = async (
  workspaceId: string,
): Promise<SpringboardCategoriesResponseDto> => {
  try {
    const response = await SpringboardCategoriesService.get({
      client: inferenceHttp,
      headers: { 'x-selected-workspace-id': workspaceId },
    });
    if (!response.data) {
      throw new Error('Failed to fetch springboard categories: empty response');
    }
    return response.data;
  } catch (error) {
    logger.error('Failed to fetch springboard categories:', error);
    throw error;
  }
};

export const upsertSpringboardCategories = async (
  workspaceId: string,
  categories: SpringboardCategoryItemDto[],
): Promise<SpringboardCategoriesResponseDto> => {
  try {
    const response = await SpringboardCategoriesService.upsert({
      client: inferenceHttp,
      headers: { 'x-selected-workspace-id': workspaceId },
      body: { categories },
    });
    if (!response.data) {
      throw new Error('Failed to save springboard categories: empty response');
    }
    return response.data;
  } catch (error) {
    logger.error('Failed to save springboard categories:', error);
    throw error;
  }
};
